<template>
  <b-form @submit.prevent="addComment">
    <b-row>
      <b-col md="12">
        <b-form-group label="Comment" label-for="comment">
          <b-form-textarea id="textarea-default" placeholder="Write your comment" rows="3" v-model="comment"
            required />
        </b-form-group>
      </b-col>
      <!-- submit and reset -->
      <b-col md="12" class="d-flex justify-content-between">
        <b-button type="submit" variant="primary">Submit<b-spinner v-if="loading" class="mx-2" /></b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AddComment",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormGroup,
    BButton,
    BSpinner
  },
  props: {
    ticketId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      comment: "",
    };
  },
  methods: {
    ...mapActions("ticketModule", ["addCommentAction"]),
    addComment(){
      this.$emit("add-comment", this.comment);
    }
  },
};
</script>
